import { render } from "./InventorySlotRooms.vue?vue&type=template&id=648d602a&scoped=true"
import script from "./InventorySlotRooms.vue?vue&type=script&lang=js"
export * from "./InventorySlotRooms.vue?vue&type=script&lang=js"

import "./InventorySlotRooms.vue?vue&type=style&index=0&id=648d602a&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648d602a"]])

export default __exports__